import React from 'react';
import { motion } from 'framer-motion';
export function LeadCopy() {
  return <section className="py-20 bg-dark-50 border-t border-dark-100" data-id="element-102">
      <div className="max-w-3xl mx-auto px-4" data-id="element-103">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="prose prose-lg prose-invert mx-auto" data-id="element-104">
          <p className="text-2xl font-medium text-white mb-8 leading-relaxed border-l-4 border-gold pl-6 italic" data-id="element-105">
            "If you’ve ever felt that sinking feeling in your stomach when a car
            dealer walks back from the finance office shaking his head... this
            is for you."
          </p>

          <div className="space-y-6 text-gray-300" data-id="element-106">
            <p data-id="element-107">
              You’ve been told that fixing your credit takes years. You’ve been
              told you need to pay "experts" hundreds of dollars a month to send
              letters on your behalf.
            </p>

            <p className="font-bold text-white text-xl" data-id="element-108">They lied.</p>

            <p data-id="element-109">
              The truth is, the credit bureaus are private companies that make
              billions selling your data. And under Federal Law—specifically{' '}
              <span className="text-gold font-bold" data-id="element-110">
                Section 609 of the FCRA
              </span>
              —if they cannot prove a debt is 100% accurate with the original
              signed contract... it must be deleted.
            </p>

            <p className="text-xl font-heading uppercase tracking-wide text-white" data-id="element-111">
              Not "updated." Not "marked as settled."{' '}
              <span className="text-danger font-bold bg-danger/10 px-2" data-id="element-112">
                DELETED.
              </span>
            </p>

            <p data-id="element-113">
              I’m going to show you how to use a "Sledgehammer" to break the
              system and win.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}